<rotec-modal-v2 [darkMode]="true" [width]="'920px'" [summary]="summary">
  <ng-container ngProjectAs="modal-main">
    <div class="pedestal-position-info-text">
      The pedestal positions are read on the integrated ruler where the left edge of the respective
      pedestal meets the scale.
    </div>
    <div class="pedestal-position-info-img">
      <img
        src="../../../assets/img/universal-pedestal-position.png"
        alt="Pedestal Position Info Image"
      />
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button translate rotec-button-primary-v2 dark (click)="close()">Close</button>
  </ng-container>
</rotec-modal-v2>
